import FilterModal from './FilterModal';
import { useDispatch } from 'react-redux';
import { setModalId, usePublicState } from '@/store/slices/publicSlice';
import Search from '@/components/categories/Search';
import { useLazyGetDisputeReportFileQuery } from '@/store/services/reports';
import FilterBtn from '../SharedComponents/FilterBtn';
import ExportBtn from '../SharedComponents/ExportBtn';
import { useDisputeFilters } from '@/store/slices/reportFiltersSlice';

export function Filters() {
  const dispatch = useDispatch();
  const filters = useDisputeFilters();
  const { search } = usePublicState();

  const searchValue = search?.disputeReportSearch || '';

  return (
    <div className="flex items-center justify-between flex-col md:flex-row gap-4">
      <Search searchName="disputeReportSearch" />
      <div className="flex items-center gap-4">
        <FilterBtn
          onClick={() => {
            dispatch(setModalId({ id: 'DISPUTES_REPORT_MODAL' }));
          }}
        />

        <ExportBtn
          useQueryHook={useLazyGetDisputeReportFileQuery}
          filters={{ ...filters, search: searchValue }}
        />
      </div>

      <FilterModal />
    </div>
  );
}

